import { render, staticRenderFns } from "./ShipperRootPage.vue?vue&type=template&id=f09b4150&scoped=true&"
import script from "./ShipperRootPage.vue?vue&type=script&lang=js&"
export * from "./ShipperRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09b4150",
  null
  
)

export default component.exports